import axios from "axios";
import qs from "qs";
export default axios.create({
  baseURL: `${window.API_URL}/api`,
  withCredentials: true,
  paramsSerializer: (params) =>
    qs.stringify(params, { indices: false, skipNulls: true }),
});
